import React from "react";
import "./App.css";
import Contacts from "./Components/Contacts/Contacts";
import Home from "./Components/Home/Home";
import NavBar from "./Components/NavBar/NavBar";
import { loadData, saveData } from "./Utils/localStorage";
import { database } from "./Firebase/firebase";
import About from "./Components/About/About";
import Resume from "./Components/Resume/Resume";
import Projects from "./Components/Projects/Projects";
import Loading from "./Components/Loading/Loading";
import { ReactComponent as DownArrowIcon } from "./Icons/arrow.svg";
import Robot from "./Components/Robot/Robot";
function App() {
  //setting the default value for theme as dark
  const [dark, setDark] = React.useState(
    loadData("theme") == null ? true : loadData("theme")
  );
  //setting the initial state
  const [loading, setLoading] = React.useState(true);
  const [profile, setProfile] = React.useState("");
  const [robotText, setRobotText] = React.useState([]);
  const [skills, setSkills] = React.useState([]);
  const [tools, setTools] = React.useState([]);
  const [projects, setProjects] = React.useState([]);
  const root = document.querySelector(":root");
  const robotTimer = React.useRef(null);
  const handleTheme = () => {
    //storing theme option in local storage
    saveData("theme", !dark);
    setDark(!dark);
  };
  // handling Robot messages
  const handleRobotText = (text) => {
    if (!robotText.includes(text)) {
      setRobotText(robotTexts=>[...robotTexts,text]);
    }
  };
  React.useEffect(() => {
    //hiding scroll bar
    root.classList.add("scroll");

    // handling theme
    if (dark) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [root, dark]);
  React.useEffect(() => {
    //get att the data from firebase
    database
      .collection("profile")
      .get()
      .then((docs) => {
        setProfile(docs.docs[0].data());
      });
    database
      .collection("skills")
      .get()
      .then((docs) => {
        setSkills(docs.docs.map((doc) => doc.data()));
      });
    database
      .collection("tools")
      .get()
      .then((docs) => {
        setTools(docs.docs.map((doc) => doc.data()));
      });
    database
      .collection("projects")
      .orderBy("priority", "asc")
      .get()
      .then((docs) => {
        setProjects(docs.docs.map((doc) => doc.data()));
      });
    
  }, []);
  React.useEffect(() => {
    if(!loading){
      robotTimer.current = setInterval(() => {
        
         setRobotText((robotTexts) =>{
           if(robotTexts.length>0){
           return robotTexts.slice(1)
           } else{
             return robotTexts;
           }
          });
        }, 3000);
    }
    return () => {
      clearInterval(robotTimer.current);
    };
  },[loading]);

  return (
    <div className="App">
      {loading && <Loading />}
      <DownArrowIcon />
      <DownArrowIcon />
      <NavBar
        handleTheme={handleTheme}
        dark={dark}
        {...profile}
        handleRobotText={handleRobotText}
      />
      <main className="mainPage scroll">
        <Home
          {...profile}
          skills={skills}
          setLoading={setLoading}
          handleRobotText={handleRobotText}
        />
        <About
          {...profile}
          skills={skills}
          tools={tools}
          handleRobotText={handleRobotText}
        />
        <Projects
          projects={projects}
          skills={[...skills, ...tools]}
          handleRobotText={handleRobotText}
        />
        {/* <Resume {...profile} /> */}
        <Contacts {...profile} handleRobotText={handleRobotText} />
      </main>
      <Robot texts={robotText} handleRobotText={handleRobotText} />
    </div>
  );
}

export default App;
